/**
 * ABN Geo-Detection & GST Checkout Validation
 * ---------------------------------------------
 * - Detects Australian visitors via IP geolocation
 * - Shows GST yes/no question only to AU visitors
 * - Yes: reveals ABN input, required before checkout
 * - No: unlocks checkout immediately, no ABN needed
 * - Checkout button disabled until question is answered
 * - Works on both cart page and Horizon cart drawer
 *
 * Place in: assets/abn-geo-checkout.js
 * Load in layout/theme.liquid before </body>:
 *   <script src="{{ 'abn-geo-checkout.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  const GEO_API    = 'https://ipapi.co/country/';
  const CACHE_KEY  = 'shopify_visitor_country';

  let gstAnswer    = null; // null | 'yes' | 'no'
  let isAustralian = false;
  let abnValidated = false;

  // ─── Selectors ───────────────────────────────────────────────────────────────

  function getWrapper()       { return document.getElementById('abn-field-wrapper'); }
  function getBtnYes()        { return document.getElementById('abn-btn-yes'); }
  function getBtnNo()         { return document.getElementById('abn-btn-no'); }
  function getNumberField()   { return document.getElementById('abn-number-field'); }
  function getInput()         { return document.getElementById('abn-input'); }
  function getError()         { return document.getElementById('abn-error'); }
 

  function getCheckoutButtons() {
    return document.querySelectorAll(
      'button[name="checkout"], button[id="checkout"], button[data-action="checkout"], a[href="/checkout"], input[name="checkout"]'
    );
  }

  // ─── Checkout button state ───────────────────────────────────────────────────

  function lockCheckout() {
    getCheckoutButtons().forEach(function (btn) {
      btn.disabled = true;
      btn.setAttribute('data-abn-locked', 'true');
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'not-allowed';
    });
  }

  function unlockCheckout() {
    getCheckoutButtons().forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('data-abn-locked');
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
      btn.style.cursor = '';
    });
  }

  // ─── Validation ──────────────────────────────────────────────────────────────

  function isValidABN(value) {
    return /^\d{11}$/.test(value.replace(/\s/g, ''));
  }

  function showError(show) {
    var error = getError();
    var input = getInput();
    if (!error || !input) return;
    if (show) {
      error.style.display = 'block';
      input.classList.add('abn-gst__input--error');
    } else {
      error.style.display = 'none';
      input.classList.remove('abn-gst__input--error');
    }
  }

  // ─── Cart API ────────────────────────────────────────────────────────────────

  function saveABNToCart(value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ABN: value, GST_Registered: gstAnswer === 'yes' ? 'Yes' : 'No' } })
    }).catch(function (err) {
      console.warn('[ABN] Cart save failed:', err);
    });
  }

  // ─── Yes / No handlers ───────────────────────────────────────────────────────

  function selectYes() {
    gstAnswer = 'yes';

    var yes = getBtnYes();
    var no  = getBtnNo();
    if (yes) { yes.classList.add('abn-gst__btn--selected'); yes.setAttribute('aria-pressed', 'true'); }
    if (no)  { no.classList.remove('abn-gst__btn--selected'); no.setAttribute('aria-pressed', 'false'); }

    var field = getNumberField();
    if (field) field.style.display = 'block';

    var input = getInput();
    if (input) input.focus();

    // Keep checkout locked until valid ABN entered
    lockCheckout();
  }

  function selectNo() {
    gstAnswer = 'no';

    var yes = getBtnYes();
    var no  = getBtnNo();
    if (yes) { yes.classList.remove('abn-gst__btn--selected'); yes.setAttribute('aria-pressed', 'false'); }
    if (no)  { no.classList.add('abn-gst__btn--selected'); no.setAttribute('aria-pressed', 'true'); }

    var field = getNumberField();
    if (field) field.style.display = 'none';

    showError(false);

    // Save "No" to cart attributes and unlock
    saveABNToCart('').then(function () {
      unlockCheckout();
    });
  }

  function resetQuestion() {
    gstAnswer = null;

    var yes = getBtnYes();
    var no  = getBtnNo();
    if (yes) { yes.classList.remove('abn-gst__btn--selected'); yes.setAttribute('aria-pressed', 'false'); }
    if (no)  { no.classList.remove('abn-gst__btn--selected'); no.setAttribute('aria-pressed', 'false'); }

    var field = getNumberField();
    if (field) field.style.display = 'none';

    showError(false);
    lockCheckout();
  }

  // ─── Checkout intercept ──────────────────────────────────────────────────────

  // Secondary safety net: even if button is unlocked, validate ABN if yes was selected
  document.addEventListener('click', function (e) {
      if (!isAustralian || abnValidated) return;

    var el = e.target.closest(
      'button[name="checkout"], button[id="checkout"], button[data-action="checkout"], a[href="/checkout"], input[name="checkout"]'
    );
    if (!el) return;

    // If no answer yet, block and scroll to question
    if (gstAnswer === null) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var wrapper = getWrapper();
      if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    // If yes selected, validate ABN
    if (gstAnswer === 'yes') {
      var value = (getInput() ? getInput().value : '').replace(/\s/g, '');
      if (!isValidABN(value)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showError(true);
        var input = getInput();
        if (input) { input.scrollIntoView({ behavior: 'smooth', block: 'center' }); input.focus(); }
        return;
      }
      // Valid — save then let checkout proceed
     e.preventDefault();
e.stopImmediatePropagation();
saveABNToCart(value).then(function () {
  abnValidated = true;
  el.click();
  abnValidated = false;
});
    }
    // gstAnswer === 'no' — button already unlocked, let it proceed naturally
  }, true);

  // ─── Event binding (delegated — handles drawer re-renders) ───────────────────

  function bindEvents() {
    document.addEventListener('click', function (e) {
      if (e.target.id === 'abn-btn-yes') { selectYes(); return; }
      if (e.target.id === 'abn-btn-no')  { selectNo();  return; }

    });

    document.addEventListener('input', function (e) {
      if (e.target.id !== 'abn-input') return;
      e.target.value = e.target.value.replace(/\D/g, '');
      if (isValidABN(e.target.value)) {
        showError(false);
        unlockCheckout();
      } else {
        lockCheckout();
      }
    });

    document.addEventListener('blur', function (e) {
      if (e.target.id !== 'abn-input') return;
      var value = e.target.value.trim();
      if (value.length > 0 && !isValidABN(value)) {
        showError(true);
      }
    }, true);
  }

  // ─── Show field + MutationObserver (survives drawer re-renders) ──────────────

  function showAndWatchField() {
    function revealWrapper() {
      var wrapper = getWrapper();
      if (wrapper) {
        wrapper.style.display = 'block';
        wrapper.setAttribute('aria-hidden', 'false');
      }
      // Re-lock checkout if question unanswered after re-render
      if (gstAnswer === null || (gstAnswer === 'yes' && !isValidABN((getInput() || {value:''}).value))) {
        lockCheckout();
      }
    }

    revealWrapper();

    var observer = new MutationObserver(function () {
      var wrapper = getWrapper();
      if (wrapper && wrapper.style.display === 'none') {
        revealWrapper();
      }
      // Re-lock any freshly rendered checkout buttons
      if (gstAnswer === null || (gstAnswer === 'yes' && !isValidABN((getInput() || {value:''}).value))) {
        lockCheckout();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ─── Geo detection ───────────────────────────────────────────────────────────

  function detectCountry() {
    return new Promise(function (resolve) {
      var cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) { resolve(cached); return; }

      fetch(GEO_API)
        .then(function (r) { return r.text(); })
        .then(function (country) {
          country = country.trim().toUpperCase();
          sessionStorage.setItem(CACHE_KEY, country);
          resolve(country);
        })
        .catch(function () {
          resolve('AU'); // safe fallback
        });
    });
  }

  // ─── Init ────────────────────────────────────────────────────────────────────

  function init() {
    bindEvents();

    detectCountry().then(function (country) {
     if (country === 'AU') {
        isAustralian = true;
        lockCheckout(); // lock immediately while field loads
        showAndWatchField();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();